// extracted by mini-css-extract-plugin
export default {"wrapper":"AnnotationControls_wrapper__nO9Ly","wrapper__no_header":"AnnotationControls_wrapper__no_header__fsah-","pagination":"AnnotationControls_pagination__SgYNu"};